import React from 'react';
import axios from 'axios'
import { Table, Input, Button,Tooltip,Popover,Popconfirm,message,DatePicker,Descriptions,Modal,Spin,Tabs,Collapse,Form,Switch, Card } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon from '@ant-design/icons';
import { SearchOutlined,DeleteOutlined,MailFilled,DownloadOutlined,PlusOutlined,PrinterOutlined,FundViewOutlined,EditOutlined,CloseCircleOutlined,WalletFilled,LoadingOutlined,FilePdfFilled } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import CurrencyFormat from 'react-currency-format';
import * as serverconfig from '../serverconn'
import * as reactstrp from 'reactstrap';
import ReactToPrint from 'react-to-print';
import {
  Col,
  Row,
} from 'reactstrap';
import ReactExport from "@ibrahimrahmani/react-export-excel";
import LoanExtras from './LoanExtras';

var CryptoJS = require("crypto-js");

const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const dateFormat = 'DD/MM/YYYY';
const { RangePicker } = DatePicker;


function callback(key) {
  console.log(key);
}

const { TabPane } = Tabs;
const FormItem=Form.Item;

var sacco= ''
var bizuserid= ''
var token= ''


class ReceiptToPrint extends React.Component {

  state = {
    companyprofile:{}
  };

  componentDidMount(){
    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
    }else{
       sacco= ''
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
    .then(res => {  
        this.setState({
          companyprofile: res.data
        })

    })

  }

//calculate principleTotal
calculateScheduleTotal=()=>{
  var principleTotal=0
  this.props.loanschedule.map(
    (item)=>{
      principleTotal+=Number(item.principle)
    })

  return principleTotal;
}

  //calculate principleTotal
  calculateInterestTotal=()=>{
    var InterestTotal=0
    this.props.loanschedule.map(
      (item)=>{
        InterestTotal+=Number(item.interest)
      })

    return InterestTotal.toFixed(2);
  }

  //calculate principleTotal
  calculateTotalPay=()=>{
    var TotalPay=0
    this.props.loanschedule.map(
      (item)=>{
        TotalPay+=Number(item.total)
      })

    return TotalPay.toFixed(2);
  }



  render() {
    return (
      <div style={{padding:20}}>
            
      <Row> 
                <Col xs="2" sm="2" lg="2">
                <img height="100" width="120"  alt="Logo" src={this.state.companyprofile.sacco_logo} />
              
                  </Col>
                  <Col xs="6" sm="6" lg="6">
                  <h3>{this.state.companyprofile.sacco_name}</h3>
                  <h6>Tel: {this.state.companyprofile.RegisteredPhoneNumber1}
                  {
                  this.state.companyprofile.RegisteredPhoneNumber2==""?
                  "":","+this.state.companyprofile.RegisteredPhoneNumber2
                  }
                  {
                  this.state.companyprofile.RegisteredPhoneNumber3==""?
                  "":","+this.state.companyprofile.RegisteredPhoneNumber3
                  }
                  </h6>               
                  <h5>Email: {this.state.companyprofile.company_email}</h5>
                  <h5>Wesite: {this.state.companyprofile.website}</h5>
                  <h5>{this.state.companyprofile.box_number}</h5>

                  </Col>

              </Row>
                  <h3 style={{fontWeight:'bolder',display: 'flex',justifyContent:'center', alignItems:'center'}}> LOAN SCHEDULE </h3>
                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}> LOAN NUMBER:  {this.props.loanissueobject.loan_number} </h4>

                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}> ACCOUNT NUMBER:  {this.props.loanissueobject.accountNumber} </h4>
                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}> ACCOUNT NAME:  {this.props.loanissueobject.accountName} </h4>

                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}> AMOUNT: <CurrencyFormat value={this.props.loanissueobject.approved_amount} displayType={'text'} thousandSeparator={true}/> UGX</h4>
                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}> PERIOD: {this.props.loanissueobject.loan_period} MONTHS</h4>
                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}>GRACE PERIOD: {this.props.loanissueobject.grace_period} DAYS</h4>

                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}>ANNUAL INTEREST RATE: {this.props.loanissueobject.interest_rate}</h4>
                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'end'}}> DATE OF ISSUANCE: {this.props.loanissueobject.date}</h4>

           <reactstrp.Table bordered>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Date</th>
                            <th>Principle Bf</th>
                            <th>Principle Pay</th>
                            <th>Interest Pay</th>
                            <th>Total Pay</th>
                            <th>Principle Bal</th>
                          </tr>
                        </thead>
                        <tbody>
                        {this.props.loanschedule.map(
                          (item)=>(
                            <tr>
                            <td>{item.repayment_number}</td>
                            <td>{item.date}</td>
                            <td>{<CurrencyFormat value={item.principlebroughtforward} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td>{<CurrencyFormat value={item.principle} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td>{<CurrencyFormat value={item.interest} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td>{<CurrencyFormat value={item.total} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td>{<CurrencyFormat value={item.balance} displayType={'text'} thousandSeparator={true}/>}</td>
                            </tr>
                          ))}
                          <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td style={{fontWeight:'bold'}}>{<CurrencyFormat value={this.calculateScheduleTotal()} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td style={{fontWeight:'bold'}}>{<CurrencyFormat value={this.calculateInterestTotal()} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td style={{fontWeight:'bold'}}>{<CurrencyFormat value={this.calculateTotalPay()} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td></td>
                          </tr>

                      </tbody>
                  </reactstrp.Table>   

                                  <br></br>
                <h3>Generated by: {CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)}</h3>
                <h3>Powered by: www.pitech.co.ug</h3>        

    </div>
    );
  }
}


class StatementToPrint extends React.Component {

  state = {
    companyprofile:{}
  };

  componentDidMount(){
    if(localStorage.getItem("sacco")){
      sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
   }else{
      sacco= ''
   }
   
   if(localStorage.getItem("token")){
      token= localStorage.getItem("token")
   }else{
      token= ''
   }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
    .then(res => {  
        this.setState({
          companyprofile: res.data
        })

    })

  }
 //calculate principle paid
 calculateTotalPrinciplePaid=()=>{
  var TotalPay=0
  this.props.loanrepayments.map(
    (item)=>{
      TotalPay+=Number(item.principle_paid)
    })

  return TotalPay.toFixed(2);
 }

  //calculate Interest paid
  calculateTotalInterestPaid=()=>{
    var TotalPay=0
    this.props.loanrepayments.map(
      (item)=>{
        TotalPay+=Number(item.interest_paid)
      })

    return TotalPay.toFixed(2);
   }

         //calculate Total total paid
  calculateTotalTotalPaid=()=>{
    var TotalPay=0
    this.props.loanrepayments.map(
      (item)=>{
        TotalPay+=Number(item.total_paid)
      })

    return TotalPay.toFixed(2);
   }

   //calculate total fine paid
   calculateTotalFinePaid=()=>{
    var TotalPay=0
    this.props.loanrepayments.map(
      (item)=>{
        TotalPay+=Number(item.fine_paid)
      })

    return TotalPay.toFixed(2);
   }


  render() {
    return (
      <div style={{padding:20}}>
            
      <Row> 
                <Col xs="2" sm="2" lg="2">
                <img height="100" width="120"  alt="Logo" src={this.state.companyprofile.sacco_logo} />
              
                  </Col>
                  <Col xs="6" sm="6" lg="6">
                  <h3>{this.state.companyprofile.sacco_name}</h3>
                  <h6>Tel: {this.state.companyprofile.RegisteredPhoneNumber1}
                  {
                  this.state.companyprofile.RegisteredPhoneNumber2==""?
                  "":","+this.state.companyprofile.RegisteredPhoneNumber2
                  }
                  {
                  this.state.companyprofile.RegisteredPhoneNumber3==""?
                  "":","+this.state.companyprofile.RegisteredPhoneNumber3
                  }
                  </h6>               
                  <h5>Email: {this.state.companyprofile.company_email}</h5>
                  <h5>Wesite: {this.state.companyprofile.website}</h5>
                  <h5>{this.state.companyprofile.box_number}</h5>

                  </Col>

              </Row>
                  <h3 style={{fontWeight:'bolder',display: 'flex',justifyContent:'center', alignItems:'center'}}> LOAN STATEMENT </h3>
                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}> LOAN NUMBER:  {this.props.loanissueobject.loan_number} </h4>

                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}> ACCOUNT NUMBER:  {this.props.loanissueobject.accountNumber} </h4>
                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}> ACCOUNT NAME:  {this.props.loanissueobject.accountName} </h4>

                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}> AMOUNT: <CurrencyFormat value={this.props.loanissueobject.approved_amount} displayType={'text'} thousandSeparator={true}/> UGX</h4>
                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}> PERIOD: {this.props.loanissueobject.loan_period} MONTHS</h4>
                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}>GRACE PERIOD: {this.props.loanissueobject.grace_period} DAYS</h4>

                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}>ANNUAL INTEREST RATE: {this.props.loanissueobject.interest_rate}</h4>
                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'end'}}> DATE OF ISSUANCE: {this.props.loanissueobject.date}</h4>

                  <reactstrp.Table bordered>
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>User</th>
                            <th>Desc</th>
                            <th>Principle Paid</th>
                            <th>Interest Paid</th>
                            <th>Fine Paid</th>
                            <th>Total Paid</th>
                            <th>Principle Balance</th>
                            <th>Interest Balance</th>
                            <th>Total Balance</th>
                     
                          </tr>
                        </thead>
                        <tbody>
                        {this.props.loanrepayments.map(
                          (item)=>(
                            <tr>
                            <td>{item.date}</td>
                            <td>{item.user==null?item.payment_by:item.user}</td>
                            <td>{item.description}</td>
                            <td>{<CurrencyFormat value={item.principle_paid} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td>{<CurrencyFormat value={item.interest_paid} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td>{<CurrencyFormat value={item.fine_paid} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td>{<CurrencyFormat value={item.total_paid} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td>{<CurrencyFormat value={item.principle_balance} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td>{<CurrencyFormat value={item.interest_balance} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td>{<CurrencyFormat value={item.loan_balance} displayType={'text'} thousandSeparator={true}/>}</td>
                            </tr>
                          ))}
                          <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td style={{fontWeight:'bold'}}>{<CurrencyFormat value={this.calculateTotalPrinciplePaid()} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td style={{fontWeight:'bold'}}>{<CurrencyFormat value={this.calculateTotalInterestPaid()} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td style={{fontWeight:'bold'}}>{<CurrencyFormat value={this.calculateTotalFinePaid()} displayType={'text'} thousandSeparator={true}/>}</td>

                          <td style={{fontWeight:'bold'}}>{<CurrencyFormat value={this.calculateTotalTotalPaid()} displayType={'text'} thousandSeparator={true}/>}</td>
                          <td></td>
                          <td></td>
                          <td></td>
                        
                          </tr>

                      </tbody>
                  </reactstrp.Table>      

                                  <br></br>
                <h3>Generated by: {CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)}</h3>
                <h3>Powered by: www.pitech.co.ug</h3>    

    </div>
    );
  }
}



class LoanFines_Print extends React.Component {

  state = {
    companyprofile:{}
  };

  componentDidMount(){
    if(localStorage.getItem("sacco")){
      sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
   }else{
      sacco= ''
   }
   
   if(localStorage.getItem("token")){
      token= localStorage.getItem("token")
   }else{
      token= ''
   }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
    .then(res => {  
        this.setState({
          companyprofile: res.data
        })

    })

  }


   //calculate total fine paid
   calculateTotalFinePaid=()=>{
    var TotalPay=0
    this.props.loanrepayments.map(
      (item)=>{
        TotalPay+=Number(item.fine_paid)
      })

    return TotalPay.toFixed(2);
   }


    //calcultae cumulative fine
    calculateTotalcumulativefine=()=>{
    var TotalPay=0
    this.props.accumulated_fines.map(
      (item)=>{
        TotalPay+=Number(item.fine_attached)
      })

    return TotalPay.toFixed(2);
    }


  render() {
    return (
      <div style={{padding:20}}>
            
      <Row> 
                <Col xs="2" sm="2" lg="2">
                <img height="100" width="120"  alt="Logo" src={this.state.companyprofile.sacco_logo} />
              
                  </Col>
                  <Col xs="6" sm="6" lg="6">
                  <h3>{this.state.companyprofile.sacco_name}</h3>
                  <h6>Tel: {this.state.companyprofile.RegisteredPhoneNumber1}
                  {
                  this.state.companyprofile.RegisteredPhoneNumber2==""?
                  "":","+this.state.companyprofile.RegisteredPhoneNumber2
                  }
                  {
                  this.state.companyprofile.RegisteredPhoneNumber3==""?
                  "":","+this.state.companyprofile.RegisteredPhoneNumber3
                  }
                  </h6>               
                  <h5>Email: {this.state.companyprofile.company_email}</h5>
                  <h5>Wesite: {this.state.companyprofile.website}</h5>
                  <h5>{this.state.companyprofile.box_number}</h5>

                  </Col>

              </Row>
                  <h3 style={{fontWeight:'bolder',display: 'flex',justifyContent:'center', alignItems:'center'}}> CUMULATIVE FINES REPORT </h3>
                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}> LOAN NUMBER:  {this.props.loanissueobject.loan_number} </h4>

                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}> ACCOUNT NUMBER:  {this.props.loanissueobject.accountNumber} </h4>
                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}> ACCOUNT NAME:  {this.props.loanissueobject.accountName} </h4>

                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}> AMOUNT: <CurrencyFormat value={this.props.loanissueobject.approved_amount} displayType={'text'} thousandSeparator={true}/> UGX</h4>
                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}> PERIOD: {this.props.loanissueobject.loan_period} MONTHS</h4>
                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}>GRACE PERIOD: {this.props.loanissueobject.grace_period} DAYS</h4>

                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'flex-end'}}>ANNUAL INTEREST RATE: {this.props.loanissueobject.interest_rate}</h4>
                  <h4 style={{fontWeight:'bolder',display: 'flex', alignItems:'end'}}> DATE OF ISSUANCE: {this.props.loanissueobject.date}</h4>


                  <reactstrp.Table bordered>
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Interest unpaid</th>
                            <th>Principle unpaid</th>
                            <th>Attached fine</th>

                          </tr>
                        </thead>
                        <tbody>
                        {this.props.accumulated_fines.map(
                          (item)=>(
                            <tr>
                            <td>{item.date}</td>
                            <td>{<CurrencyFormat value={item.unpaid_interest.toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td>{<CurrencyFormat value={item.unpaid_principle.toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>
                            <td>{<CurrencyFormat value={item.fine_attached.toFixed(2)} displayType={'text'} thousandSeparator={true}/>}</td>

                            </tr>
                          ))}
                          <tr>
                          <td>Total</td>
                          <td></td>
                          <td></td>

                          <td style={{fontWeight:'bold'}}>{<CurrencyFormat value={this.calculateTotalcumulativefine()} displayType={'text'} thousandSeparator={true}/>}</td>
                        
                          </tr>

                      </tbody>
                      </reactstrp.Table>

                     <br></br>
                <h3>Generated by: {CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)}</h3>
                <h3>Powered by: www.pitech.co.ug</h3>    

    </div>
    );
  }
}



class LoanIssuanceList extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    loanissues: [],
    viewpaymentmodal:false,
    expensedetails:{},
    userprofile:{},
    datarequested:true,

    current_selected_loan:0,
    loan_particular_data_loading:false,

    loanschedule:[],
    loanissueobject:{},
    loanrepayments:[],
    companyprofile:{},
    loanfines:[],

    deletelist:[],
    totaltobepaidobject:{},
    interestpay:0,

    newreschdate:'',
    newreschamt:0,
    waiver_model_visible:false,
    
    
    schedule_edit_interest_value:0,
    schedule_edit_principe_value:0,
    schedule_edit_total_value:0,
    selected_scheduleobject:{},

    payment_model_visible:false,
    interest_paid:0,
    principle_paid:0,
    fine_paid:0,
    total_paid:0,
    interest_balance:0,
    principle_balance:0,
    total_balance:0,
    selected_paymentobject:{},

    accumulated_fines:[],
    fullypaid_loans: [],
    send_email_tonon_member:false,
    non_memberemailaddress:'',

    dateone:'',
    datetwo:'',
    userrights:{},
    current_txn_date:'',



  };

  componentDidMount(){
    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
       bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
    
    }else{
       sacco= ''
       bizuserid= ''
    
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    let form_data = new FormData();
    form_data.append('userid', bizuserid);
    
    //get the user profile here
    axios.post(serverconfig.backendserverurl+'/customqueries/get_user_profile',form_data,{
      headers: {
        'content-type': 'multipart/form-data'
      }
      })
    .then(res => {
        this.setState({
          userprofile:res.data
        })
    })


    let form_data1 = new FormData();
    form_data1.append('action', "initialdata");
    form_data1.append('sacco', sacco);
    axios.post(serverconfig.backendserverurl+`/customqueries/get_allloans`,form_data1)
    .then(res => {
        this.setState({
          loanissues:JSON.parse(res.data.report)
        })
        this.setState({
          fullypaid_loans:JSON.parse(res.data.report_fullypaid)
        })
        this.setState({datarequested:false})
    })


    axios.get(serverconfig.backendserverurl+`/api/accountrights/?user=${bizuserid}`)
    .then(res => {
        this.setState({
          userrights:res.data[0]
        })
    })


    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
    .then(res => {  
        this.setState({
          companyprofile: res.data
        })

    })

}


  //calculate principleTotal
  calculateScheduleTotal=()=>{
    var principleTotal=0
    this.state.loanschedule.map(
      (item)=>{
        principleTotal+=Number(item.principle)
      })

    return principleTotal.toFixed(2);
  }

    //calculate principleTotal
    calculateInterestTotal=()=>{
      var InterestTotal=0
      this.state.loanschedule.map(
        (item)=>{
          InterestTotal+=Number(item.interest)
        })
  
      return InterestTotal.toFixed(2);
    }

    //calculate principleTotal
    calculateTotalPay=()=>{
      var TotalPay=0
      this.state.loanschedule.map(
        (item)=>{
          TotalPay+=Number(item.total)
        })
  
      return TotalPay.toFixed(2);
    }


      //calculate principle paid
      calculateTotalPrinciplePaid=()=>{
      var TotalPay=0
      this.state.loanrepayments.map(
        (item)=>{
          TotalPay+=Number(item.principle_paid)
        })
  
      return TotalPay.toFixed(2);
     }
  
      //calculate Interest paid
      calculateTotalInterestPaid=()=>{
        var TotalPay=0
        this.state.loanrepayments.map(
          (item)=>{
            TotalPay+=Number(item.interest_paid)
          })
    
        return TotalPay.toFixed(2);
       }

             //calculate Total total paid
      calculateTotalTotalPaid=()=>{
        var TotalPay=0
        this.state.loanrepayments.map(
          (item)=>{
            TotalPay+=Number(item.total_paid)
          })
    
        return TotalPay.toFixed(2);
       }

       //calculate total fine paid
       calculateTotalFinePaid=()=>{
        var TotalPay=0
        this.state.loanrepayments.map(
          (item)=>{
            TotalPay+=Number(item.fine_paid)
          })
    
        return TotalPay.toFixed(2);
       }


      //calculate total fine paid
      calculateTotaldailyFine=()=>{
        var TotalPay=0
        this.state.loanfines.map(
          (item)=>{
            TotalPay+=Number(item.cyclefine)
          })
    
        return TotalPay.toFixed(2);
        }

        //calcultae cumulative fine
        calculateTotalcumulativefine=()=>{
          var TotalPay=0
          this.state.accumulated_fines.map(
            (item)=>{
              TotalPay+=Number(item.fine_attached)
            })
      
          return TotalPay.toFixed(2);
          }


    //////////////////////////////////////////////////
  //handle delete here
  handleDelete = id => {
      let form_data = new FormData();
      form_data.append('loanid', id);
      form_data.append('sacco',sacco);
      form_data.append('user',bizuserid);

      axios.post(serverconfig.backendserverurl+'/customqueries/deleteloan', form_data, {
        headers: {
          'content-type': 'multipart/form-data'
        }
      })
    .then(res => window.location.reload(false),message.info('Success fully deleted Loan')
    )
    .catch(error => console.log(error))
   
  };


getColumnSearchProps = dataIndex => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Input
        ref={node => {
          this.searchInput = node;
        }}
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        style={{ width: 188, marginBottom: 8, display: 'block' }}
      />
      <Button
        type="primary"
        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        icon={<SearchOutlined />}
        size="small"
        style={{ width: 90, marginRight: 8 }}
      >
        Search
      </Button>
      <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
        Reset
      </Button>
    </div>
  ),
  filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
  onFilter: (value, record) =>
    record[dataIndex]
      .toString()
      .toLowerCase()
      .includes(value.toLowerCase()),
  onFilterDropdownVisibleChange: visible => {
    if (visible) {
      setTimeout(() => this.searchInput.select());
    }
  },
  render: text =>
    this.state.searchedColumn === dataIndex ? (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ) : (
      text
    ),
});

handleSearch = (selectedKeys, confirm, dataIndex) => {
  confirm();
  this.setState({
    searchText: selectedKeys[0],
    searchedColumn: dataIndex,
  });
};

handleReset = clearFilters => {
  clearFilters();
  this.setState({ searchText: '' });
};

  render() {

      var columns = [
        {
          title: 'Loan number',
          dataIndex: 'loan_number',
          key: 'id',
          ...this.getColumnSearchProps('loan_number'),
          render:(text,record)=>
          <div>
          <h5> {record.loan_number}</h5>

          {
            Number(record.paidtotalprinciple)>=Number(record.approved_amount)?
            <p style={{color:"green"}}>Cleared</p>
            :
            <p style={{color:record.status==="active"?"green":'red'}}>( {record.status} )</p>
          }

          </div>
        },
        {
          title: 'Loan top up?',
          dataIndex: 'loantopup',
          key: 'id',
          ...this.getColumnSearchProps('loantopup'),
          render:(text,record)=>
          <p>
            {text} | 
            {text==="Yes"?<Link to={`/loanissues/${record.loantopup_id}`}>Top up reference</Link>:null}
          </p>

        },
        {
          title: 'Loan officer',
          dataIndex: 'loan_officername',
          key: 'id',
          ...this.getColumnSearchProps('loan_officername'),

        },

        {
          title: 'Loan type',
          dataIndex: 'loantypename',
          key: 'id',
          ...this.getColumnSearchProps('loantypename'),

        },

        {
          title: 'Issuance Date',
          dataIndex: 'date',
          key: 'id',
          ...this.getColumnSearchProps('date'),
        },
        {
          title: 'Maturity Date',
          dataIndex: 'maturity_date',
          key: 'id',
          ...this.getColumnSearchProps('maturity_date'),
        },
        {
          title: 'No of days to expiry',
          dataIndex: 'no_ofdays_toexpiry',
          key: 'id',
          ...this.getColumnSearchProps('no_ofdays_toexpiry'),
        },

        {
          title: 'Account Number',
          dataIndex: 'accountNumber',
          key: 'id',
          ...this.getColumnSearchProps('accountNumber'),
        },
        {
          title: 'Account Name',
          dataIndex: 'accountName',
          key: 'id',
          ...this.getColumnSearchProps('accountName'),
        },
        {
          title: 'Loan Amount',
          dataIndex: 'approved_amount',
          key: 'id',
          render:text=><CurrencyFormat value={text} displayType={'text'} thousandSeparator={true}  />
        },

        {
          title: 'Loan Period',
          dataIndex: 'loan_period',
          key: 'id',
          render:(text,record)=><h5>{text} ({record.loan_primary_schedule})</h5>
        },

        {
          title: 'Cycles due',
          dataIndex: 'cycles_due',
          key: 'id',
        },
        {
          title: 'Principle due',
          dataIndex: 'principle_due',
          key: 'id',
          render:text=><CurrencyFormat value={text} displayType={'text'} thousandSeparator={true}  />
        },
        {
          title: 'Interest due',
          dataIndex: 'intrest_due',
          key: 'id',
          render:text=><CurrencyFormat value={text} displayType={'text'} thousandSeparator={true}  />
        },


        {

          title: 'Principle paid',
          dataIndex: 'paidtotalprinciple',
          key: 'id',
          render:text=><CurrencyFormat value={text} displayType={'text'} thousandSeparator={true}  />
        },
        {
          title: 'Interest paid',
          dataIndex: 'paidtotalinterest',
          key: 'id',
          render:text=><CurrencyFormat value={text} displayType={'text'} thousandSeparator={true}  />
        },
        {
          title: 'Fine paid',
          dataIndex: 'finepaid',
          key: 'id',
          render:text=><CurrencyFormat value={text} displayType={'text'} thousandSeparator={true}  />
        },

        {
          title: 'Interest arrears',
          dataIndex: 'interest_arrears',
          key: 'id',
          render:text=><CurrencyFormat value={text} displayType={'text'} thousandSeparator={true}  />
        },

        {
          title: 'Principle arrears',
          dataIndex: 'principle_arrears',
          key: 'id',
          render:text=><CurrencyFormat value={text} displayType={'text'} thousandSeparator={true}  />
        },
        {
          title: 'Total arrears',
          dataIndex: 'total_arrears',
          key: 'id',
          render:text=><CurrencyFormat value={text} displayType={'text'} thousandSeparator={true}  />
        },

        {
          title: 'Outstanding principle balance',
          dataIndex: 'totoutstanding_PrBal',
          key: 'id',
          render:text=><CurrencyFormat value={text} displayType={'text'} thousandSeparator={true}  />
        },

        {
          title: 'Outstanding interest balance',
          dataIndex: 'totoutstanding_IntBal',
          key: 'id',
          render:text=><CurrencyFormat value={text} displayType={'text'} thousandSeparator={true}  />
        },

        {
          title: 'Outstanding total balance',
          dataIndex: 'total_outstanding',
          key: 'id',
          render:text=><CurrencyFormat value={text} displayType={'text'} thousandSeparator={true}  />
        },


        {
          title: 'Action',
          dataIndex: 'id',
          key: 'id',
          render: (text,record) =>
          <p>
          <Popover content={<p>Click here to view details(Schedule & Statement)</p>} title="View">
           <Link to={`/loanissues/${text}`}><FundViewOutlined style={{color:'blue'}}/></Link>
          </Popover>
          &nbsp;&nbsp;

          <Popover content={<p>Click here to view attached guarantors)</p>} title="View">
           <Link to={`/loanguarantors/${record.loan}`}><FundViewOutlined style={{color:'green'}}/></Link>
          </Popover>
          &nbsp;&nbsp;

          <Popover content={<p>Click here to view attached consents</p>} title="View">
           <Link to={`/loanconsents/${record.loan}`}><FundViewOutlined style={{color:'orange'}}/></Link>
          </Popover>

          </p>,
        }
  
      ];

  
    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <Spin size="large">
                <div className="content" />
              </Spin>       
        </div>
      )

    }else{
      return(
        <div>
            <div style={{display: "none"}}>
            &nbsp;&nbsp;
            <ReceiptToPrint
            loanschedule={this.state.loanschedule} 
            date={this.state.datetoday} 
            loanissueobject={this.state.loanissueobject}
            ref={el => (this.componentRef = el)} /> 
            </div>


            <div style={{display: "none"}}>
            &nbsp;&nbsp;
            <StatementToPrint
            loanrepayments={this.state.loanrepayments} 
            date={this.state.datetoday} 
            loanissueobject={this.state.loanissueobject}
            ref={sel => (this.componentReftwo = sel)} /> 
            </div>

            <div style={{display: "none"}}>
            &nbsp;&nbsp;
            <LoanFines_Print
            accumulated_fines={this.state.accumulated_fines} 
            date={this.state.datetoday} 
            loanissueobject={this.state.loanissueobject}
            ref={el => (this.componentRef_fines = el)} /> 
            </div>

            <div style={{display:'flex',justifyContent:'flex-start',alignSelf:'flex-start',alignItems:'flex-start'}}>
            <ExcelFile filename={"Pisacco - Active and inactive loans report "} element={<Button type='primary' icon={<DownloadOutlined/>} style={{margin:10}}>Download Excel report</Button>}>
                  <ExcelSheet data={this.state.loanissues} name={"Active loans"}>
                      <ExcelColumn label="Loan number" value="loan_number"/>
                      <ExcelColumn label="Status" value="status"/>
                      <ExcelColumn label="Loan top up" value="loantopup"/>
                      <ExcelColumn label="Loan officer" value="loan_officername"/>
                      <ExcelColumn label="Loan type" value="loantypename"/>
                      <ExcelColumn label="Issuance date" value="date"/>
                      <ExcelColumn label="Maturity date" value="maturity_date"/>
                      <ExcelColumn label="Days to expiry" value="no_ofdays_toexpiry"/>

                      <ExcelColumn label="Loan period" value="loan_period"/>

                      <ExcelColumn label="Account number" value="accountNumber"/>
                      <ExcelColumn label="Account name" value="accountName"/>
                      <ExcelColumn label="Loan amount" value="approved_amount"/>

                      <ExcelColumn label="Cycles due" value="cycles_due"/>
                      <ExcelColumn label="Principle due" value="principle_due"/>
                      <ExcelColumn label="Interest due" value="intrest_due"/>

                      <ExcelColumn label="Principle paid" value="paidtotalprinciple"/>
                      <ExcelColumn label="Interest paid" value="paidtotalinterest"/>
                      <ExcelColumn label="Fine paid" value="finepaid"/>

                      <ExcelColumn label="Principle arrears" value="principle_arrears"/>
                      <ExcelColumn label="Interest arrears" value="interest_arrears"/>
                      <ExcelColumn label="Total arrears" value="total_arrears"/>


                      <ExcelColumn label="Outstanding interest balance" value="totoutstanding_IntBal"/>
                      <ExcelColumn label="Outstanding principle balance" value="totoutstanding_PrBal"/>
                      <ExcelColumn label="Total outstanding balance" value="total_outstanding"/>


                  </ExcelSheet>


                  <ExcelSheet data={this.state.fullypaid_loans} name={"Cleared loans"}>
                      <ExcelColumn label="Loan number" value="loan_number"/>
                      <ExcelColumn label="Status" value="status"/>
                      <ExcelColumn label="Loan top up" value="loantopup"/>
                      <ExcelColumn label="Loan officer" value="loan_officername"/>
                      <ExcelColumn label="Loan type" value="loantypename"/>
                      <ExcelColumn label="Issuance date" value="date"/>
                      <ExcelColumn label="Maturity date" value="maturity_date"/>
                      <ExcelColumn label="Days to expiry" value="no_ofdays_toexpiry"/>

                      <ExcelColumn label="Loan period" value="loan_period"/>

                      <ExcelColumn label="Account number" value="accountNumber"/>
                      <ExcelColumn label="Account name" value="accountName"/>
                      <ExcelColumn label="Loan amount" value="approved_amount"/>

                      <ExcelColumn label="Cycles due" value="cycles_due"/>
                      <ExcelColumn label="Principle due" value="principle_due"/>
                      <ExcelColumn label="Interest due" value="intrest_due"/>

                      <ExcelColumn label="Principle paid" value="paidtotalprinciple"/>
                      <ExcelColumn label="Interest paid" value="paidtotalinterest"/>
                      <ExcelColumn label="Fine paid" value="finepaid"/>

                      <ExcelColumn label="Principle arrears" value="principle_arrears"/>
                      <ExcelColumn label="Interest arrears" value="interest_arrears"/>
                      <ExcelColumn label="Total arrears" value="total_arrears"/>


                      <ExcelColumn label="Outstanding interest balance" value="totoutstanding_IntBal"/>
                      <ExcelColumn label="Outstanding principle balance" value="totoutstanding_PrBal"/>
                      <ExcelColumn label="Total outstanding balance" value="total_outstanding"/>



                  </ExcelSheet>
              </ExcelFile>


              <Form  layout="inline" >
                  <FormItem label="Search by issuance period">
                      <RangePicker  onChange={(date, dateString) =>{
                          this.setState({ dateone: dateString[0]});
                          this.setState({ datetwo: dateString[1]});
                        } } format={dateFormat} />
                  </FormItem>

                <FormItem>
                <Button onClick={()=>{

                if(this.state.dateone==='' || this.state.datetwo===''){
                  alert("Date one or two missing")
                  }else{        

                    this.setState({datarequested:true})
                    let form_data1 = new FormData();
                    form_data1.append('action', "daterange");
                    form_data1.append('sacco', sacco);
                    form_data1.append('dateone', this.state.dateone);
                    form_data1.append('datetwo', this.state.datetwo);

                    axios.post(serverconfig.backendserverurl+`/customqueries/get_allloans`,form_data1)
                    .then(res => {
                        this.setState({
                          loanissues:JSON.parse(res.data.report)
                        })
                        this.setState({
                          fullypaid_loans:JSON.parse(res.data.report_fullypaid)
                        })
                        this.setState({datarequested:false})
                    })

                  }

                }} type="primary" htmlType="button">Search</Button>
                </FormItem> 

              </Form>

              </div>

            <Tabs defaultActiveKey="1" onChange={callback}>

            {
              /**
               * 
               * ACTIVE LOANS
               * 
               * 
               * 
               * 
               * 
               * 
               * 
               * 
               * 
               * 
               * 
               * 
               * 
               */
            }




          <TabPane tab="Active loans" key="001" >
          <Table   
            columns={columns} 
            size='small'

            expandable={{
              expandedRowRender: (record) =>{
                  return (
                    <div
                      style={{
                        margin: 0,
                      }}
                     >
                      <LoanExtras loanissueID={record.id} />

                    </div>
                    );
               
              } ,
              rowExpandable: (record) => record.id !== this.state.current_selected_loan.id,
              onExpand:(condition,record)=>{

              },
            }}


            scroll={{ x: 1000 }}
            dataSource={this.state.loanissues} 
            pagination={{showQuickJumper:true,showSizeChanger:true }}
            bordered/>
            <br/>
            <h3>Total: {this.state.loanissues.length}</h3>
          
                
                </TabPane>


            {
              /**
               * 
               * NON ACTIVE LOANS
               * 
               * 
               * 
               * 
               * 
               * 
               * 
               * 
               * 
               * 
               * 
               * 
               * 
               */
            }


                <TabPane tab="Cleared loans" key="002" >
                <Table   
                  columns={columns} 
                  size='small'

                  expandable={{
                    expandedRowRender: (record) =>{
                        return (
                          <div
                            style={{
                              margin: 0,
                            }}
                          >
                          <LoanExtras loanissueID={record.id} />
                          </div>
                          );
                    } ,
                    rowExpandable: (record) => true,
                    onExpand:(condition,record)=>{

                    },
                  }}

                  scroll={{ x: 1000 }}
                  dataSource={this.state.fullypaid_loans} 
                  pagination={{showQuickJumper:true,showSizeChanger:true }}
                  bordered/>
                  <br/>
                  <h3>Total: {this.state.fullypaid_loans.length}</h3>
              </TabPane>

            </Tabs>

        </div> 
         )

    }
    
  }
}

export default LoanIssuanceList; 
